import React from "react"

import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import isMobileDevice from "@irati/utils/mobile"
import {Body} from "@irati/ui/src/Typography"

import {Wrapper, StyledLink} from "./styled"

interface Props extends InjectIntl {
  onClick: () => void
  link: string
  text: string
  activationCode: string
  isGrey?: boolean
  isMarginLarge?: boolean
}

const ContinueOnline: React.FC<Props> = (props) => {
  const {onClick, link, isGrey, isMarginLarge, text, activationCode, formatMessage} = props

  if (isMobileDevice()) {
    return null
  }
  return (
    <Wrapper isMarginLarge={isMarginLarge}>
      <Body small marginBottom={1} display="inline">
        <FormattedMessage id="medical.code.continueOnline.text" />
      </Body>
      <StyledLink
        isGrey={isGrey}
        onClick={onClick}
        inBody
        uppercase={false}
        href={formatMessage({id: link}, {activationCode})}
        target="_blank"
        rel="noopener noreferrer">
        <FormattedMessage id={text} />
      </StyledLink>
    </Wrapper>
  )
}

export default injectIntl(ContinueOnline)

